export async function fetchWidgetEmbeddingByUrl({
  apiBaseUrl,
  agentId,
  masterKey,
  url,
  signal,
}) {
  const base = String(apiBaseUrl || '').replace(/\/$/, '')
  if (!base) throw new Error('apiBaseUrl is required')
  if (!agentId) throw new Error('agentId is required')
  if (!url) throw new Error('url is required')

  const mk =
    typeof masterKey === 'string' ? masterKey.trim() : String(masterKey || '').trim()

  const body = {
    agentId,
    url,
    ...(mk ? { master_key: mk } : {}),
  }

  const res = await fetch(`${base}/api/v1/widget/embeddings/lookup`, {
    method: 'POST',
    signal,
    credentials: 'omit',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(mk ? { 'X-Master-Key': mk } : {}),
    },
    body: JSON.stringify(body),
  })

  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(
      `Embeddings lookup failed (${res.status}): ${text || res.statusText || 'Unknown error'}`,
    )
  }

  const json = await res.json()
  const row = json && typeof json === 'object' ? json.data : null
  return row && typeof row === 'object' ? row : null
}

